import clsx from 'clsx'
import { useEffect } from 'react'
import PropTypes from 'prop-types'
import InputWithTooltipPlaceholder from './InputWithTooltipPlaceholder'

/**
 * Ported from pitstop-ui/src/components/EForm/FormField/cell-number.jsx
 *
 * Changes:
 *   - `classnames` → `clsx`
 *   - Removed unused `useRef`
 *   - InputWithTooltipPlaceholder import path corrected to local ./
 */

const INPUT_BASE =
  'box-border w-full h-[45px] pt-3 px-[14px] pb-[10px] type-body-2 text-grey-10 border border-grey-90 rounded-[5px] bg-white shadow-none transition-[border-color] duration-150 ease-in-out appearance-none focus:border-theme-50 focus:outline-none disabled:text-grey-50 disabled:cursor-not-allowed disabled:pointer-events-none disabled:bg-grey-98'

function getClassName(error) {
  return clsx(INPUT_BASE, error && 'border-red-50 focus:border-red-50')
}

const CellNumberComponent = ({
  error,
  isReadOnly,
  schema,
  payload,
  parentProps,
  inputProps,
  setInputProps,
  updatePayload,
  validateSchema,
  getFieldValue,
}) => {
  const isIntegerType = () => {
    if (!schema) return false
    if (schema.type === 'integer') return true
    if (Array.isArray(schema.type) && schema.type.includes('integer')) return true
    return false
  }

  useEffect(() => {
    const fieldValue = getFieldValue(payload, parentProps)
    const valueProp =
      fieldValue !== null && fieldValue !== undefined && fieldValue !== ''
        ? { value: fieldValue }
        : {}

    setInputProps({
      ...inputProps,
      ...valueProp,
      disabled: isReadOnly,
      placeholder: isReadOnly ? null : schema.description || schema.title || '',
      type: isIntegerType() ? 'text' : 'number',
      pattern: isIntegerType() ? '-?\\d*' : undefined,
      value:
        getFieldValue(payload, parentProps) === null ? '' : getFieldValue(payload, parentProps),
    })
  }, [payload, isReadOnly, schema])

  function onChange(e) {
    if (isReadOnly) return
    let value = e.target.value

    if (value === '') {
      setInputProps({ ...inputProps, value: undefined })
      updatePayload(null)
      validateSchema(null)
      return
    }

    if (isIntegerType()) {
      const integerRegex = /^-?\d*$/
      if (!integerRegex.test(value)) return
      if (value !== '-') {
        value = Number(value)
        setInputProps({ ...inputProps, value })
      }
    } else {
      const doubleRegex = /^-?\d*\.?\d*$/
      if (!doubleRegex.test(value)) {
        if (/[eE]/.test(value)) return
      }
      if (value !== '-' && value !== '-.' && !value.endsWith('.')) {
        value = Number(value)
        setInputProps({ ...inputProps, value })
      }
    }

    updatePayload(value)
    validateSchema(value)
  }

  return (
    <InputWithTooltipPlaceholder
      {...inputProps}
      onChange={onChange}
      className={getClassName(error)}
    />
  )
}

CellNumberComponent.propTypes = {
  error: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  schema: PropTypes.object,
  payload: PropTypes.object,
  parentProps: PropTypes.array,
  inputProps: PropTypes.object,
  setInputProps: PropTypes.func,
  updatePayload: PropTypes.func,
  validateSchema: PropTypes.func,
  getFieldValue: PropTypes.func,
}

export default CellNumberComponent
